import { combineEpics } from 'redux-observable';
import {
  searchCruiseEpic,
  searchCruiseEpicAir,
  searchItineraryEpic,
  searchCabinAndDatesEpic,
  searchCabinAndDatesEpicAir,
  searchItineraryButtonEpic,
  searchMultifilterEpic,
  searchFacetsEpic,
  searchMultipleCabinsAndDatesEpic,
  searchMultipleCabinsAndDatesEpicAir,
  searchExcursionsEpic,
  searchExcursionsButtonEpic,
} from './search/searchEpics';
import {
  itineraryDetailsEpic,
  itineraryExcursionsEpic,
  itineraryPortsGalleryEpic,
} from './itinerary/itineraryEpics';
import { analyticsEpic } from './analytics/analyticsEpics';
export const epics = combineEpics(
  searchFacetsEpic,
  searchItineraryEpic,
  searchItineraryButtonEpic,
  searchMultifilterEpic,
  searchCruiseEpic,
  searchCruiseEpicAir,
  searchCabinAndDatesEpic,
  searchCabinAndDatesEpicAir,
  itineraryDetailsEpic,
  itineraryExcursionsEpic,
  searchMultipleCabinsAndDatesEpic,
  searchMultipleCabinsAndDatesEpicAir,
  searchExcursionsEpic,
  searchExcursionsButtonEpic,
  itineraryPortsGalleryEpic,
  ...analyticsEpic // Add epic for Analytics
);
